// Postupné zobrazování položek po data-load-more-step kusech (výchozí 3).
// Položky nad první dávku jsou ze šablony skryté třídou 'none', tlačítko
// odkryje další dávku a po poslední se samo schová.
export default class LoadMore {
    static init(): void {
        const containers: NodeListOf<HTMLElement> = document.querySelectorAll('.js-load-more');

        containers.forEach((container) => {
            const button: HTMLElement | null = container.querySelector('.js-load-more-button');
            const step = Number(container.dataset.loadMoreStep) || 3;

            if (!button) {
                return;
            }

            button.addEventListener('click', () => {
                const hidden = container.querySelectorAll('.js-load-more-item.none');

                // nové položky najedou postupně jedna po druhé (_gallery-section.scss)
                Array.from(hidden)
                    .slice(0, step)
                    .forEach((item, index) => {
                        const element = item as HTMLElement;

                        element.style.animationDelay = `${index * 0.1}s`;
                        element.classList.remove('none');
                        element.classList.add('load-more-item--entering');
                    });

                if (hidden.length <= step) {
                    button.classList.add('none');
                }
            });
        });
    }
}
